import { trpc } from '@/shared/api/trpc';

export const useAvailableTaskCollections = (itineraryId: string | undefined) =>
  trpc.taskCollections.availableForItinerary.useQuery(
    { itineraryId: itineraryId ?? '' },
    { enabled: Boolean(itineraryId) }
  );
